import { useBreakpoint } from "../useBreakpoint/useBreakpoint.hook.js";
import { BREAKPOINTS_FONT_SIZE_MULTIPLIER } from "./constants.js";

export const useRootFontSizeScale = () => {
    const { minFontSize, maxFontSize, baseFontSize } = {
        minFontSize: 16,
        maxFontSize: 16,
        baseFontSize: 12,
    };

    const breakpoint = useBreakpoint();

    const newFontSize = Math.max(minFontSize, Math.min(maxFontSize, Math.trunc(baseFontSize * BREAKPOINTS_FONT_SIZE_MULTIPLIER[breakpoint])));

    return newFontSize;
};
